export const loadEinbliq = () => import('./einbliq');
